(() => {
  const reveal = (root) => {
    const els = (root || document).querySelectorAll('.vv-s .rv:not(.in)');
    if (!('IntersectionObserver' in window) || window.Shopify && window.Shopify.designMode) { els.forEach(el => el.classList.add('in')); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    els.forEach(el => io.observe(el));
  };
  const forms = (root) => {
    (root || document).querySelectorAll('form.vv-join-form').forEach(form => {
      if (form.dataset.bound) return; form.dataset.bound = '1';
      form.addEventListener('submit', () => {
        const tags = ['founding-list'];
        form.querySelectorAll('input[data-vv-tag]:checked').forEach(c => tags.push(c.value));
        form.querySelectorAll('input[data-vv-text]').forEach(i => { const v = (i.value || '').replace(/[,<>]/g, ' ').replace(/\s+/g, ' ').trim().slice(0, 90); if (v) tags.push(i.dataset.vvText + ': ' + v); });
        const t = form.querySelector('input[name="contact[tags]"]');
        if (t) t.value = tags.join(', ');
      });
    });
  };
  const vids = (root) => {
    (root || document).querySelectorAll('.vv-s .vid[data-yt]').forEach(b => {
      if (b.dataset.bound) return; b.dataset.bound = '1';
      b.addEventListener('click', () => {
        if (b.querySelector('iframe')) return;
        const f = document.createElement('iframe');
        f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(b.dataset.yt) + '?autoplay=1&rel=0';
        f.allow = 'autoplay; encrypted-media; picture-in-picture'; f.allowFullscreen = true; f.title = b.getAttribute('aria-label') || 'Video';
        b.appendChild(f);
      });
    });
  };
  const init = (root) => { reveal(root); forms(root); vids(root); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
